import o from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function d(e) {
  a(1, arguments);
  var r = o(e), t = r.getSeconds();
  return t;
}
export {
  d as default
};
